import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BatchInterface,
  CreateBatchInterface,
  onClose,
} from 'src/app/shared/interfaces';

export const batchActions = createActionGroup({
  source: 'batch',
  events: {
    'load batches': emptyProps(),
    'set batches': props<{ data: BatchInterface[] }>(),
    'get admission batch': props<{ admissionId: string }>(),
    'set admission batch': props<{ data: BatchInterface }>(),
    create: props<{
      data: CreateBatchInterface;
      onClose: onClose;
    }>(),
    update: props<{
      data: CreateBatchInterface;
      id: string;
      onClose: onClose;
    }>(),
  },
});
